document.addEventListener('DOMContentLoaded', function () {

	let btnSubmitCart = document.querySelector('.product-form__submit');
  
	btnSubmitCart.addEventListener('click', function () {
  
		let is_onetime_purchase = document.getElementById('is_onetime_field').value;
  
		const productTitleDiv = document.querySelector('.product__title');
		const h1Element = productTitleDiv.querySelector('h1');
		const h1Text = h1Element.textContent;
		const containsKeywords = 
			h1Text.includes("Designer Panels") || h1Text.includes("Quality Monitor") || h1Text.includes("Power Cord") || h1Text.includes("Pack");
	  
  
		//HTLM HIDDEN INPUTS
		let inpSubSelectedF = document.querySelector('input[name="id"]');
		let inpSubIntervals = document.querySelector('input[name="properties[_subscription_available_intervals]"]');
		let inpSubInterval  = document.querySelector('input[name="properties[_subscription_filter_interval]"]');
		let inpSubDate      = document.querySelector('input[name="properties[_subscription_filter_date]"]');
		let inpSubPrice     = document.querySelector('input[name="properties[_subscription_filter_price]"]');
		let inpSubTitle     = document.querySelector('input[name="properties[_subscription_filter_title]"]');
		let inpSubImage     = document.querySelector('input[name="properties[_subscription_filter_image]"]');
		let inpSubAval      = document.querySelector('input[name="properties[_subscription_available_unit]"]');
		let inpPlansAval    = document.querySelector('input[name="properties[_subscription_available_plans]"]');
		let inpSelProd      = document.querySelector('input[name="properties[_subscription_product_selection]"]');
		let inpSubsType     = document.querySelector('input[name="properties[_subscription_type]"]');
		let inpSubSellingP  = document.querySelector('input[name="selling_plan"]');
		let inpHasSub       = document.querySelector('input[name="properties[_has_recharge_sub]"]');
		let presaleInput    = document.getElementById("imp-pre-sale-input");
		let productType     = document.getElementById("shopify-product-type").value;

		let objSelectInterval = document.getElementById("future-subscription");
  
		let interval;
		let future_date;
		let selling_plan = '';

		if(objSelectInterval)
			interval    = Number(objSelectInterval.value);
  
		let intervals   = selected_variant_intervals;
		let selling_plans_obj   = selling_plans_str;
	
		future_date = document.getElementById('future-filter-date');
  
		if(future_date) {
			future_date = future_date.innerHTML.trim();
		}
  
		let recurring_price = selected_variant_price;
	 	let product_title   = selected_variant_title;
  
		if(objSelectInterval)
			selling_plan    = objSelectInterval.options[objSelectInterval.selectedIndex].getAttribute('data-selling-id');
  
		let filter_subscription_image = filter_image;
	
		let json_properties = {
			"properties": {
				"_subscription_filter_selection": inpSubSelectedF.value,
				"_subscription_filter_interval": interval,
				"_subscription_available_intervals": intervals,
				"_subscription_filter_image": filter_subscription_image,
				"_subscription_available_unit": "month",
				"_subscription_filter_date": future_date,
				"_subscription_filter_price": recurring_price,
				"_subscription_filter_title": product_title,
				"_subscription_available_plans": selling_plans_obj,
				"_subscription_selling_plan": selling_plan,
				"_subscription_product_selection": inpSelProd.value,
				"_has_recharge_sub": true,
				"_presale_discount": presaleInput.value,
				"_shopify_product_type": productType
			}
		};
  
		if(containsKeywords == true) {
			inpHasSub.remove();
		}
  
	  	const hiddenOriginalPriceEl = document.getElementById("imp-origial-product-price");
  
		if(inpSubsType.value == 'Air-Filter') {
				const compareAtPriceEl = document.querySelector('.price-item.price-item--regular.pdp-price');
	
				if (hiddenOriginalPriceEl && compareAtPriceEl && compareAtPriceEl.textContent.trim() !== '' && compareAtPriceEl.textContent !== undefined) {
					hiddenOriginalPriceEl.value = compareAtPriceEl.textContent.trim();
				}
	
				if(product_title.includes('Pack')) {
					const compareAtPricePackEl = document.querySelector('.price-item.price-item--sale.price-item--last.pdp-price');
					hiddenOriginalPriceEl.value = compareAtPricePackEl.textContent.trim();
				}
	
				if (hiddenOriginalPriceEl.value == ''){
					hiddenOriginalPriceEl.value = '';
				}

				if(is_onetime_purchase == 'true') {
					const priceEl = document.querySelector('.recharge-regular-price');
					hiddenOriginalPriceEl.value = priceEl.textContent.trim();
				} else {
					const compareAtPriceEl = document.querySelector('.recharge-discount-price');
					hiddenOriginalPriceEl.value = compareAtPriceEl.textContent.trim();
				}

				setJsonCookie(`_recharge_properties_${inpSubSelectedF.value}`,json_properties,1);
		} else {
				const compareAtPriceEl = document.querySelector('s.price-item.price-item--regular');
	
				if (hiddenOriginalPriceEl && compareAtPriceEl && compareAtPriceEl.textContent.trim() !== '' && compareAtPriceEl.textContent !== undefined) {
					hiddenOriginalPriceEl.value = compareAtPriceEl.textContent.trim();
				} else {
					hiddenOriginalPriceEl.value = '';
				}
	
			setJsonCookie(`_recharge_properties_${inpSelProd.value}`,json_properties,1);
		}
  
		if(containsKeywords == false) {
			if(is_onetime_purchase == 'true') {
				inpSubIntervals.value = '';
				inpSubInterval.value  = '';
				inpSubDate.value      = '';
				inpSubPrice.value     = '';
				inpSubTitle.value     = '';
				inpSubImage.value     = '';
				inpSubSellingP.value  = '';
				inpSubAval.value      = '';
				inpSubSelectedF.value = '';
				inpPlansAval.value    = '';
				inpSelProd.value      = '';
				inpHasSub.remove();
			} else {
				inpSubIntervals.value = intervals;
				inpSubInterval.value  = interval;
				inpSubDate.value      = future_date;
				inpSubPrice.value     = recurring_price;
				inpSubTitle.value     = product_title;
				inpSubImage.value     = filter_subscription_image;
				inpSubSellingP.value  = selling_plan;
				inpPlansAval.value    = selling_plans_obj;
				if (!inpHasSub){
					var newInput = document.createElement("input");
					
					newInput.type = "hidden";
					newInput.name = "properties[_has_recharge_sub]";
					
					btnSubmitCart.parentElement.appendChild(newInput);
				}
			}
		}
	});
  });